module.exports = __webpack_public_path__ + "assets/img/jiangbei.d8289f95.png";